import Layout from "components/structure/Layout";
import React, { useContext, useEffect, useState } from "react";
import { Button, CircularProgress, Grid, Typography } from "@mui/material";
import plusIcon from "../../../../src/assets/plusIcon.svg"
import { Box } from "@mui/system";
import HierarchyModal from "./HierrachyModal";
import HierarchyTable from "./HierarchyTable";
import HierarchyService from "services/HierarchyService";
import { SnackbarContext } from "context/snackBarContext";
import Pagination from "./Paginationcc";
import { AuthData } from "auth/AuthWarpper";

const HierarchyContainer = () => {
    const { user } = AuthData();
    const [modalOpen, setModalOpen] = useState(false);
    const [hierarchyData, sethierarchyData] = useState(null);
    const [loading, setLoading] = useState(false);
    const { setOpenAlert, setSeverity, setMessage, handleClose } =
        useContext(SnackbarContext);
    const [string, setString] = React.useState("");

    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(5); // Number of items per page
    const [totalItems, setTotalItems] = useState(5); // Number of items per page



    useEffect(() => {
        callHierarchyAPI(currentPage, itemsPerPage)
    }, []);

    const callHierarchyAPI = (pNumber, size) => {
        setLoading(true)
        HierarchyService.FetchAllHierarchy({ pageNumber: pNumber, size: size })
            .then((res) => {
                setCurrentPage(pNumber)
                setItemsPerPage(size)
                setLoading(false)
                sethierarchyData(res?.data?.response);
                setTotalItems(res?.data?.response?.totalItems)
            }).catch((error) => {
                setLoading(false)
                setMessage(error?.response?.data?.message || error?.message)
                setOpenAlert(true)
                setSeverity("error")
            })
    }


    const onSubmitLevel = () => {
        let level = {
            hlcLevelName: string,
            createdByUser: user ? user.userName : "",
            modifiedByUser: user ? user.userName : "",
            country: user ? user.countryCode : "",
        }
        setLoading(true)
        HierarchyService.addLevel(level).then((res) => {
            setLoading(false)
            setMessage("Added successfully")
            setOpenAlert(true)
            setSeverity("success")
            callHierarchyAPI(currentPage, itemsPerPage)
            setModalOpen(false);
            setString("")


        }).catch((error) => {
            setLoading(false)
            setMessage(error?.response?.data?.message || error?.message)
            setOpenAlert(true)
            setSeverity("error")
        })

    }


    const paginate = (pageNumber, itemsPerPage) => {
        callHierarchyAPI(pageNumber - 1, itemsPerPage)
    }

    const handleInputChange = (str) => {
        const noSpaces = str.replace(/\s/g, '');
        setString(noSpaces);
    };
    return (
            <Layout title={"Hierarchy Level Configuration"}>
            <div className="hierarchyConatiner">
                <Grid item xs={13} md={12} display={"flex"} sx={{flexDirection:{xs:"column" ,md:"row"}}} justifyContent={"space-between"}>
                    <Box sx={{
                        display:"flex",
                        alignItems:"center",
                        fontWeight: 600,
                        fontSize: "1.25rem",
                        color: "rgba(115, 125, 134, 1)",
                    }}>
                        Hierarchy Configuration List
                    </Box>
                    <Box sx={{ right: '1.6rem', padding: "10px" }}>
                        <Button style={{ backgroundColor: "#004F9F", borderRadius: "30px" }}
                            variant="contained"
                            startIcon={<img src={plusIcon} />}
                            onClick={() => setModalOpen(true)}
                        >
                            Add new Level</Button>
                    </Box>
                </Grid>
                <HierarchyTable setHierarchynull={() => sethierarchyData([])} callHierarchyAPI={() => callHierarchyAPI(currentPage, itemsPerPage)} hierarchyData={hierarchyData}></HierarchyTable>
                {!hierarchyData || hierarchyData.length == 0 ?
                    <Typography style={{ textAlign: "center", marginTop: "5%" }}>No Data</Typography>
                    : ""
                }

                <HierarchyModal loading={loading} string={string} onLevelNameInput={(str) => { handleInputChange(str) }} onNext={() => { onSubmitLevel() }} open={modalOpen} onClose={() => { setModalOpen(false) }} />
            </div>
            <div style={{ position: "absolute", width: "96%", bottom: "24px" }}>
                {hierarchyData && hierarchyData?.hierarchyLevelConfig &&
                    <Pagination
                        itemsPerPage={itemsPerPage}
                        totalItems={totalItems}
                        paginate={paginate}
                        currentPage={currentPage}
                    />
                }

            </div>

        </Layout>
    );
};


export default HierarchyContainer;




